module.exports = __webpack_public_path__ + "static/media/Logo_RZ_CMYK_iQ_IMAGE_Tag.74512a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/Logo_RZ_CMYK_iQ_IMAGE_Tag.png
// module id = 561
// module chunks = 0